.portfolioAttr {
  display: flex;
  flex-direction: column;
  align-items: first baseline;
  justify-content: space-between;
  gap: 0.15rem;
  margin: 0.55rem 1rem;
}

.attrTitle {
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.045em;
}

.attrVal {
  text-align: left;
  font-weight: 700;
  font-variant-numeric: tabular-nums lining-nums;
}

.netIRR {
  composes: attrVal;
  font-weight: bold;
}
